/*global */
import React, { Component } from 'react';

class IconLabel extends Component {
    render () {
        return <div className='flex-row' style={{"alignItems":"center"}}><img className='mr-3' src={this.props.icon} width="18" height="18"/> <span className='font16'>{this.props.label}</span></div>
    }
};

export default IconLabel